import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[autofocus]'
})
export class AutofocusDirective implements OnChanges {

  @Input() autofocus: boolean;

  constructor(
    private el: ElementRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['autofocus'] && changes['autofocus'].currentValue) {
      setTimeout(() => {
        this.focusFirstFocusableElement(this.el.nativeElement);
      }, 500);
    }
  }

  private focusFirstFocusableElement(element: HTMLElement) {
    const focusableElements = this.findFocusableElements(element);
    if (focusableElements.length > 0) {
      (<any>focusableElements[0]).focus();
    }
  }

  private findFocusableElements(element: HTMLElement) {
    return Array.from(element.querySelectorAll('input, select, textarea, button, a[href], [tabindex]:not([tabindex="-1"])'))
      .filter(el => !el.hasAttribute('disabled'));
  }
}
